/*
 * MOQ (minimum order quantity) enforcement — Yuva theme.
 * Reads the minimum from the min / data-min attribute on quantity inputs
 * and the data-moq attribute on product forms (both rendered from the
 * product's custom.minimum_order_quantity metafield via snippets/moq.liquid).
 *
 *  Product page / quick-add popup:
 *   - typing a number below the minimum snaps it back up
 *   - clicking "Add to cart" below the minimum is blocked with a message
 *  Sticky add-to-cart / collection-grid add-to-cart (no visible quantity box):
 *   - a hidden quantity equal to the MOQ is submitted
 *  Cart page / cart drawer:
 *   - the "−" button and typed values cannot go below the MOQ (0 / remove still works)
 */
(function () {
  var strings = window.moqStrings || {
    product: 'Minimum order quantity for this product is [min].',
    cart: 'Minimum order quantity is [min]. Use remove to delete this item.'
  };

  function toInt(v, fallback) {
    var n = parseInt(v, 10);
    return isNaN(n) ? fallback : n;
  }

  function showMessage(container, text) {
    if (!container) return;
    container.textContent = text;
    container.style.display = '';
    container.classList.add('moq-active');
    clearTimeout(container._moqTimer);
    container._moqTimer = setTimeout(function () {
      container.textContent = '';
      container.classList.remove('moq-active');
      if (container.classList.contains('productErrors')) container.style.display = 'none';
    }, 5000);
  }

  function productMessageContainer(form) {
    var section = form.closest('.shopify-section') || form.closest('product-info') || document;
    var el = section.querySelector('.productErrors');
    if (el) return el;
    el = document.createElement('div');
    el.className = 'error-text moq-message';
    el.setAttribute('role', 'alert');
    form.appendChild(el);
    return el;
  }

  /* ---------- product forms (add to cart) ---------- */

  function productMin(form, input) {
    var moq = toInt(form.getAttribute('data-moq'), 1);
    if (input) {
      // The theme lowers min when the cart already holds the minimum for this
      // variant, so prefer the live attribute when it exists.
      var live = toInt(input.getAttribute('min'), NaN);
      if (!isNaN(live)) return Math.max(1, live);
    }
    return Math.max(1, moq);
  }

  function quantityInputFor(form) {
    var el = form.elements['quantity'];
    if (el && el.length && !el.tagName) el = el[0];
    return el && el.tagName === 'INPUT' ? el : null;
  }

  // Shopper typed a number and tabbed / clicked away (product page + quick add).
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('input[type="number"][name="quantity"]')) return;
    var form = input.form;
    if (!form) return;
    var min = productMin(form, input);
    if (toInt(input.value, 0) < min) {
      input.value = min;
      showMessage(productMessageContainer(form), strings.product.replace('[min]', min));
    }
  }, true);

  // Shopper clicked "Add to cart" (theme handles this via a delegated jQuery
  // click on .Sd_addProduct, so a capture-phase listener runs first).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.Sd_addProduct');
    if (!btn) return;
    var form = btn.form || btn.closest('form');
    if (!form || !form.hasAttribute('data-moq')) return;
    var input = quantityInputFor(form);
    var min = productMin(form, input);

    if (!input) {
      // No quantity box in this form (sticky bar, collection grid): submit the MOQ.
      if (min > 1) {
        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'quantity';
        hidden.value = min;
        form.appendChild(hidden);
      }
      return;
    }

    if (toInt(input.value, 0) < min) {
      e.preventDefault();
      e.stopImmediatePropagation();
      input.value = min;
      showMessage(productMessageContainer(form), strings.product.replace('[min]', min));
    }
  }, true);

  /* ---------- cart page + cart drawer ---------- */

  function cartInputFor(el) {
    var wrap = el.parentElement;
    return wrap ? wrap.querySelector('input[name="updates[]"]') : null;
  }

  function cartMessageContainer(input) {
    var line = input.getAttribute('data-line');
    var el = line ? document.getElementById('cartItemError-' + line) : null;
    if (el) return el;
    // Cart drawer: put the message on its own full-width row under the qty/price line.
    var row = input.closest('.cart-item-price') || input.parentElement.parentElement;
    el = row.parentElement.querySelector('.moq-message');
    if (!el) {
      el = document.createElement('div');
      el.className = 'cart-item-error error-text moq-message';
      el.setAttribute('role', 'alert');
      el.style.cssText = 'flex:0 0 100%;width:100%;margin-top:6px;font-size:0.85em;line-height:1.3;';
      row.insertAdjacentElement('afterend', el);
    }
    return el;
  }

  // "−" button in the cart page (.line_item_change) or drawer (.ajaxcart__qty--minus):
  // block if it would drop below the MOQ (but not to 0).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.quantity-down');
    if (!btn) return;
    var input = cartInputFor(btn);
    if (!input) return;
    var min = toInt(input.getAttribute('data-min'), 1);
    if (min <= 1) return;
    var step = toInt(input.getAttribute('step'), 1);
    var next = toInt(input.value, 0) - step;
    if (next > 0 && next < min) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showMessage(cartMessageContainer(input), strings.cart.replace('[min]', min));
    }
  }, true);

  // Typed value in the cart: snap up to the MOQ, then let the theme save it.
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('input[name="updates[]"]')) return;
    var min = toInt(input.getAttribute('data-min'), 1);
    if (min <= 1) return;
    var val = toInt(input.value, 0);
    if (val > 0 && val < min) {
      input.value = min;
      // The theme's own change handler clears the error slot synchronously, so show ours just after it.
      setTimeout(function () {
        showMessage(cartMessageContainer(input), strings.cart.replace('[min]', min));
      }, 50);
    }
  }, true);
})();
